import { vec3 } from 'gl-matrix';
import { atom } from 'recoil';
import { Image3D } from '~/domain/patient/image3d';
import { ImageViewMode } from '~/engine/core/render/renderers/ImageRenderer';

export const defaultCheckerboardDensity = 0.5;

export type FusionColorMapping = {
    id: string;
    name: string;
    primaryValues: vec3;
    secondaryValues: vec3;
    previewPrimary: string;
    previewSecondary: string;
};

export const grayscaleFusionColorMapping: FusionColorMapping = {
    id: 'noColorMapping',
    name: 'No color mapping',
    primaryValues: [1.0, 1.0, 1.0],
    secondaryValues: [1.0, 1.0, 1.0],
    previewPrimary: '#FFFFFF',
    previewSecondary: '#FFFFFF',
};

export const cyanMagentaFusionColorMapping: FusionColorMapping = {
    id: 'cyanMagenta',
    name: 'Cyan\u2013Magenta',
    primaryValues: [0.0, 1.0, 1.0],
    secondaryValues: [1.0, 0.0, 1.0],
    previewPrimary: '#00FFFF',
    previewSecondary: '#FF00FF',
};

export const primaryImageState = atom<Image3D | undefined>({
    key: 'primaryImageState',
    default: undefined,
    dangerouslyAllowMutability: true,
});

export const secondaryImageState = atom<Image3D | undefined>({
    key: 'secondaryImageState',
    default: undefined,
    dangerouslyAllowMutability: true,
});

export const imageSecondaryAmountState = atom<number>({
    key: 'imageSecondaryAmountState',
    default: 50,
});

export const selectedSecondaryImageModeState = atom<ImageViewMode>({
    key: 'selectedSecondaryImageModeState',
    default: ImageViewMode.AlphaBlending,
});

export const checkerboardDensityState = atom<number>({
    key: 'checkerboardDensityState',
    default: defaultCheckerboardDensity,
});

export const selectedFusionColorMappingState = atom<FusionColorMapping>({
    key: 'selectedFusionColorMappingState',
    default: cyanMagentaFusionColorMapping,
});

/**
 * Monotonic counter incremented after mutations to domain objects
 * (e.g. image deletion) that don't change Recoil atom references.
 * Hooks that read mutable domain data should include this in their
 * dependency array to force re-evaluation.
 */
export const imageListVersionState = atom<number>({
    key: 'imageListVersionState',
    default: 0,
});
